import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

const TRACK_COLOR = {
  operator: "var(--cyan)", engineer: "var(--amber)",
  hunter: "var(--green)", leader: "var(--red)",
};

function MiniKpi({ value, label, color }) {
  return (
    <div className="border border-[var(--border)] py-2">
      <div className="font-mono text-lg" style={{ color }}>{value}</div>
      <div className="font-mono text-[10px] text-[var(--text-2)] uppercase tracking-widest">{label}</div>
    </div>
  );
}

export default function TraineeCard({ trainee, onSuggest }) {
  const r = trainee;
  return (
    <div className="flat-card p-5 group" data-testid={`squad-row-${r.email}`}>
      <Link to={`/squad/${r.id}`} className="block">
        <div className="flex items-start justify-between">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[var(--text-2)]">// PROFILE</div>
            <div className="font-display font-bold text-xl uppercase mt-0.5">{r.name}</div>
            <div className="font-mono text-xs text-[var(--text-2)] mt-1">{r.email}</div>
          </div>
          <span className="tag" style={{ color: TRACK_COLOR[r.track], borderColor: TRACK_COLOR[r.track] }}>
            {r.track}
          </span>
        </div>

        <div className="mt-4 grid grid-cols-3 gap-2 text-center">
          <MiniKpi value={`${r.avg_progress}%`} label="Progress" color="var(--cyan)" />
          <MiniKpi value={r.certs} label="Certs" color="var(--green)" />
          <MiniKpi value={r.courses} label="Courses" color="var(--amber)" />
        </div>
      </Link>

      <div className="mt-4 flex items-center justify-between gap-2">
        <button
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onSuggest(r); }}
          className="font-mono text-[10px] uppercase tracking-widest border border-[var(--cyan)] text-[var(--cyan)] hover:bg-[var(--cyan)] hover:text-[var(--bg)] px-3 py-1.5 inline-flex items-center gap-1.5 transition-colors"
          data-testid={`suggest-chip-${r.email}`}
        >
          <Sparkles size={11} /> Sentinel Suggest
        </button>
        <Link
          to={`/squad/${r.id}`}
          className="font-mono text-xs uppercase tracking-widest text-[var(--cyan)] inline-flex items-center gap-1 hover:gap-2 transition-all"
          data-testid={`squad-drill-${r.email}`}
        >
          Drill down <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
